import { useEffect } from "react";

declare global {
  interface Window {
    acsbJS?: {
      init: (options: Record<string, unknown>) => void;
    };
  }
}

export default function AccessWidget() {
  useEffect(() => {
    // L'overlay riscrive l'albero accessibile a runtime e falsa ogni verifica con
    // NVDA o axe DevTools. Resta attivo in produzione, spento in sviluppo e nei test.
    // Vedi documentazione della remediation a11y, fuori dal repo — D4.
    if (process.env.NODE_ENV !== "production") return;

    // Build di misura per NVDA e axe: `REACT_APP_NO_A11Y_OVERLAY=true npm run build`.
    // Serve perche' `npm run build` imposta NODE_ENV=production e riaccenderebbe
    // l'overlay proprio sul bundle che si va a verificare. La variabile NON sta in
    // .env (che e' tracciato in git): va passata sulla riga di comando, cosi' il
    // build di produzione resta con l'overlay attivo. Vedi decisioni.md — D4.
    if (process.env.REACT_APP_NO_A11Y_OVERLAY === "true") return;

    // Evita di inserire due volte lo script
    if (document.getElementById("acsb-script")) return;

    const script = document.createElement("script");
    script.id = "acsb-script";
    script.src = "https://eu.acsbapp.com/apps/app/dist/js/app.js";
    script.async = true;
    script.onload = () => {
      if (window.acsbJS) {
        window.acsbJS.init({
          statementLink: "",
          footerHtml:
            '<a href="https://www.accessiway.com/it/home/" target="_blank">AccessiWay. The Web Accessibility Solution</a>',
          hideMobile: false,
          hideTrigger: false,
          language: "it",
          position: "right",
          leadColor: "#fcbb00",
          triggerColor: "#fcbb00",
          triggerRadius: "50%",
          triggerPositionX: "right",
          triggerPositionY: "bottom",
          triggerIcon: "people",
          triggerSize: "medium",
          triggerOffsetX: 20,
          triggerOffsetY: 20,
          mobile: {
            triggerSize: "medium",
            triggerPositionX: "right",
            triggerPositionY: "bottom",
            triggerOffsetX: 10,
            triggerOffsetY: 10,
            triggerRadius: "50%",
          },
        });
      } else {
        console.error("acsbJS non è stato caricato correttamente");
      }
    };
    document.body.appendChild(script);
  }, []);

  return null;
}
